import { SubMenuList } from '../sub-menu-list';

export class LabelsButton extends SubMenuList {
  name = 'labels';
}
